<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 系统管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>专属税收分类</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.typeId" placeholder="请选择产品类型" @change="onChangeSearchTypeId" filterable>
					<el-option key="" label="请选择产品类型" value=""></el-option>
					<el-option v-for="item in productTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.seriesId" placeholder="请选择产品系列" filterable>
					<el-option key="" label="请选择产品系列" value=""></el-option>
					<el-option v-for="item in productSeriesSearchKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-input v-model="query.productName" placeholder="产品型号" class="handle-input mr10"></el-input>
				<el-select v-model="query.channelId" placeholder="请选择专属公司" filterable>
					<el-option key="" label="请选择专属公司" value=""></el-option>
					<el-option v-for="item in channelsKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select><br><br>
				<el-input v-model="query.code" placeholder="税收编码" class="handle-input mr10"></el-input>
				<el-input v-model="query.name" placeholder="开票名称" class="handle-input mr10"></el-input>
				<el-input v-model="query.model" placeholder="开票型号" class="handle-input mr10"></el-input>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="product" label="产品">
					<template slot-scope="scope">{{productTypeFormat(null, null, scope.row.typeId) + (scope.row.seriesName?(" / " + scope.row.seriesName):"") + (scope.row.productName?(" / " + scope.row.productName):"")}}</template>
				</el-table-column>
				<el-table-column prop="channelId" label="专属公司" :formatter="channelFormat"></el-table-column>
				<el-table-column prop="code" label="税收编码" width="160"></el-table-column>
                <el-table-column prop="name" label="开票名称"></el-table-column>				
				<el-table-column prop="model" label="开票型号" width="160"></el-table-column>
                <el-table-column label="操作" width="130" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
			<el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-form-item label="产品类型" prop="typeId">
					<el-select v-model="form.typeId" placeholder="请选择产品类型" @change="onChangeTypeId" filterable>
						<el-option key="" label="请选择产品类型" value=""></el-option>
						<el-option v-for="item in productTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="产品系列">
					<el-select v-model="form.seriesId" placeholder="请选择产品系列" filterable @change="onChangeSeriesId">
						<el-option key="" label="请选择产品系列" value=""></el-option>
						<el-option v-for="item in productSeriesKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="产品">
					<el-select v-model="form.productId" placeholder="请选择产品系列" filterable>
						<el-option key="" label="请选择产品系列" value=""></el-option>
						<el-option v-for="item in productKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="专属公司" prop="channelId">
					<el-select v-model="form.channelId" placeholder="请选择公司" filterable>
						<el-option key="" label="请选择公司" value=""></el-option>
						<el-option v-for="item in channelsKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="税收编码" prop="code">
					<el-input v-model="form.code"></el-input>
				</el-form-item>
				<el-form-item label="开票名称" prop="name">
					<el-input v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="税率" prop="taxRate">
					<el-input v-model="form.taxRate" placeholder="不同于默认税率时填写，默认税率在我的企业中设置, 0.06表示6%税率"></el-input>
				</el-form-item>
				<el-form-item label="开票型号" prop="model">
					<el-input v-model="form.model" placeholder="如开票型号和产品名称一致，则无需填写"></el-input>
				</el-form-item>
			</el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
			
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchIncomeCategoryData, saveIncomeCategory, deleteIncomeCategory, getIncomeCategory, getEnumValueKV, getProductSeriesKV, getProductKV, getChannelKV} from '../../../api/index';
export default {
    name: 'income-category',
    data() {
        return {
            query: {
				level:1,
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			productTypeEnumCode:1003,
			productTypeKV:[],
			productSeriesKV:[],
			productKV:[],
			productSeriesSearchKV:[],
			channelsKV:[],
			title:"",
			rules: {
                typeId: [{ required: true, message: '请选择所属类型', trigger: 'blur' }],
				channelId: [{ required: true, message: '请选择专属公司', trigger: 'blur' }],
				code: [{ required: true, message: '请输入税收编码', trigger: 'blur' }],
				name: [{ required: true, message: '请输入开票名称', trigger: 'blur' }]				
            },
			controll:{}
        };
    },
    created() {
		this.controll = getControll('income-category');
		this.getProductType();
		this.getChannels();
        this.getData();
    },
    methods: {	
	    //产品类型格式化
		productTypeFormat(row, column, cellValue) {
			for (var i = 0; i < this.productTypeKV.length; i++) {
				if (this.productTypeKV[i].key === cellValue){
					return this.productTypeKV[i].value;
				}
			}
			return cellValue;
		},
		//产品系列格式化
		seriesFormat(row, column, cellValue) {
			for (var i = 0; i < this.productSeriesKV.length; i++) {
				if (this.productSeriesKV[i].key === cellValue){
					return this.productSeriesKV[i].value;
				}
			}
			return cellValue;
		},
		productFormat(row, column, cellValue) {
			for (var i = 0; i < this.productKV.length; i++) {
				if (this.productKV[i].key === cellValue){
					return this.productKV[i].value;
				}
			}
			return cellValue;
		},
		channelFormat(row, column, cellValue) {
			for (var i = 0; i < this.channelsKV.length; i++) {
				if (this.channelsKV[i].key === cellValue){
					return this.channelsKV[i].value;
				}
			}
			return cellValue;
		},
		//获取渠道
		getChannels() {
			getChannelKV().then(res => {
				if (res.code == 0) {
					this.channelsKV = res.data;
				} else {
					this.$message.error(`获取渠道信息失败！` + res.message);
				}
			});
		},
		//获取产品类型
		getProductType() {
			getEnumValueKV(this.productTypeEnumCode).then(res => {
				if (res.code == 0 ) {
					this.productTypeKV = res.data;
				} else {
					this.$message.error("获取产品类型数据失败！" + res.message);
				}
			});
		},
		onChangeSearchTypeId(value) {
			this.productSeriesSearchKV = {};
			if (!value) {
				return;
			}
			getProductSeriesKV(value).then(res => {
				if (res.code == 0 ) {
					this.productSeriesSearchKV = res.data;
				} else {
					this.$message.error("获取产品系列数据失败！" + res.message);
				}
			});
		},
		//产品类型变更
		onChangeTypeId(value) {
			this.productSeriesKV = {};
			if (!value) {
				return;
			}
			getProductSeriesKV(value).then(res => {
				if (res.code == 0 ) {
					this.productSeriesKV = res.data;
				} else {
					this.$message.error("获取产品系列数据失败！" + res.message);
				}
			});
		},
		onChangeSeriesId(value) {
			this.productKV = {};
			if (!value) {
				return;
			}
			getProductKV(value).then(res => {
				if (res.code == 0 ) {
					this.productKV = res.data;
				} else {
					this.$message.error("获取产品数据失败！" + res.message);
				}
			});		
		},
		//状态格式化
		statusFormat(row, column, cellValue) {
			if (typeof(cellValue) == undefined) return cellValue;
			return cellValue?"已停产":"在产"; 
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchIncomeCategoryData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteIncomeCategory([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteIncomeCategory(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.activeName = "baseTab";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
			this.title = "编辑";
			this.activeName = "baseTab";
			getIncomeCategory(row.id).then(res => {
				if (res.code == 0) {
					this.productSeriesKV = {};
					this.productKV = {};
					this.onChangeTypeId(res.data.typeId);
					if (res.data.seriesId) {
						this.onChangeSeriesId(res.data.seriesId);
					}
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					this.form['seriesName'] = this.seriesFormat('', '', this.form['seriesId']);
					this.form['productName'] = this.productFormat('', '', this.form['productId']);
					this.form['level'] = this.query.level;
					saveIncomeCategory(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
